import './App.css';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import LogIn from './pages/Authentication/LogIn';
import DarkMode from './components/DarkMode';
import InfoOrg from './pages/Authentication/InfoOrg';
import EnviManagement from './pages/Authentication/EnviManagement';
import Management from './pages/Authentication/Management';
import WasteandEmissions from './pages/Authentication/WasteandEmissions';
import Dashboard from './pages/Authentication/Dashboard';
import InitialForm from './pages/Forms/InitialForm';
import DashboardUser from './pages/Authentication/DashboardUser';
import RecoveryPassword from './pages/Authentication/RecoveryPassword';
import CompanyProfile from './pages/Authentication/CompanyProfile';
import Companies from './pages/Companies/Companies';
import AddOrEditCompany from './pages/Forms/Company/AddOrEditCompany';
import IndicatorForm from './pages/Forms/IndicatorForm';
import CompanyEditForm from './pages/Authentication/CompanyEditForm';
import PreviewCompanyProfile from './pages/Authentication/PreviewCompanyProfile';
import AddEditEmployee from './pages/Authentication/Employees/AddEditEmployee';
import Employees from './pages/Authentication/Employees/Employees';
import Reports from './pages/Authentication/Reports/Reports';
import PreviewReport from './pages/Authentication/Reports/PreviewReport';
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import AddReport from './pages/Forms/AddReport';
import FormTemp from './pages/Forms/FormTemp';
// import CompanyEditForm2 from './pages/Authentication/CompanyEditForm2';
import { PanelProvider } from './components/PanelContext/PanelContext';
import DashboardCompany from './pages/Authentication/DashboardCompany';
import CompareProjects from './components/CompareProjects/CompareProjects';
import CompanyEditFormWithTerms from './pages/Authentication/CompanyEditFormWithTerms';
import MainThemeLayout from './layout/MainThemeLayout';
import ReportTrash from './pages/Authentication/Reports/ReportTrash';
import Dashboardv2 from './pages/Authentication/DashboardV2';

function App() {
	return (
		<PanelProvider>
			<DarkMode />
			<Routes>
				<Route element={<ProtectedRoute />}>
					<Route path="/" element={<LogIn />} />
					<Route path='/reset/:token' element={<RecoveryPassword />} />
				</Route>
				<Route element={<ProtectedRoute token={true} />}>
					<Route path="/InitForm" element={<InitialForm />} />
					<Route path="/IndicatorForm" element={<IndicatorForm />} />
					{/* <Route path="/InformacionGeneral" element={<InfoOrg />} />
					<Route path="/GestiónAmbiental" element={<EnviManagement />} />
					<Route path="/Gestión" element={<Management />} />
					<Route path="/GestiónDeResiduosyEmisiones" element={<WasteandEmissions />} /> */}
					{/* <Route path="/PanelDeControl" element={
						<MainThemeLayout load={true}>
							<div className="flex flex-col items-center justify-center h-full text-center px-4">
								<h1 className="text-3xl font-semibold text-gray-800 mb-4">
									No se ha seleccionado un proyecto
								</h1>
								<p className="text-lg text-gray-600">
									Por favor, seleccione un proyecto para visualizar el panel de control.
								</p>
							</div>
						</MainThemeLayout>
					} /> */}
					<Route path="/PanelDeControlProyecto/:idProject" element={<Dashboard load={true} />} />
					<Route path="/PanelDeControlEmpresa/:idCompany" element={<DashboardCompany />} />
					<Route path="/PanelDeControlEmpresa/:idCompany/:idProject" element={<DashboardCompany />} />
					{/* <Route path="/PanelDeControlUsuario" element={<DashboardUser />} /> */}
					<Route path="/PanelDeControl" element={<Dashboardv2 />} />

					{/* Grupo de rutas para las organizaciones */}
					<Route path="/Organizaciones">
						<Route index element={<Companies />} />
						<Route path="Agregar" element={<AddOrEditCompany />} />
						<Route path="Editar/:id" element={<CompanyEditFormWithTerms />} />
					</Route>
					<Route path='/PerfilDeLaOrganizacion' element={<PreviewCompanyProfile />} />
					<Route path='/EditarOrganizacion' element={<CompanyEditFormWithTerms />} />
					<Route path='/VerPerfilOrg/:id' element={<PreviewCompanyProfile />} />
					<Route path='/Empleados' element={<Employees />} />
					<Route path='/AgregarEmpleado' element={<AddEditEmployee />} />
					<Route path='/EditarEmpleado/:id' element={<AddEditEmployee />} />
					<Route path='/Reportes' element={<Reports />} />
					<Route path='/PapeleraReportes' element={<ReportTrash />} />
					<Route path='/AgregarReporte' element={<AddReport withLayout={true} withLogo={true} />} />
					<Route path='/EditarReporte/:id/:date' element={<AddReport withLayout={true} withLogo={true} />} />
					<Route path='/VerReporte/:id/:date' element={<PreviewReport />} />
					<Route path='/VerReporte/:company_id/:id/:date' element={<PreviewReport />} />
					<Route path='/CompararProyectos' element={<CompareProjects />} />
				</Route>
			</Routes>
		</PanelProvider>
	);
}

export default App;
